<template>
  <div class="recipe">
    <myNav />
    <div class="y900">
      <div class="uload1">
        <el-upload
          drag=""
          class="upload-demo"
          action="http://chengqifu.com/index.php/Index/PushPic"
          :on-success="handleAvatarSuccess1"
          :before-upload="beforeAvatarUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__tip" slot="tip">
            将营业执照jpg文件拖拽至框内上传
          </div>
        </el-upload>
        <div class="bz">请保证图片的清晰度</div>
        <div class="scbtn">上传营业执照</div>
      </div>
      <div class="uload2">
        <el-upload
          drag=""
          class="upload-demo"
          action="http://chengqifu.com/index.php/Index/PushPic"
          :on-success="handleAvatarSuccess2"
          :before-upload="beforeAvatarUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__tip" slot="tip">
            将代理记账许可证书jpg文件拖拽至框内上传
          </div>
        </el-upload>
        <div class="bz">请保证图片的清晰度</div>
        <div class="scbtn">上传证书</div>
      </div>
      <div class="uload3">
        <el-upload
          class="upload-demo"
          drag
          action="http://chengqifu.com/index.php/Index/PushFile"
          :on-success="handleAvatarSuccess3"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__tip" slot="tip">
            将其他文件压缩拖拽至框内上传
          </div>
        </el-upload>
        <div class="bz">请保证图片的清晰度</div>
        <div class="scbtn">上传其他文件</div>
      </div>
      <div class="form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item class="left_wz" label="公司名称" prop="name">
            <el-input
              class="input_C"
              v-model="ruleForm.name"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item class="left_wz" label="联系方式" prop="phone">
            <el-input
              class="input_C"
              v-model="ruleForm.phone"
              placeholder="请输入联系方式"
            ></el-input>
          </el-form-item>
          <el-button
            class="tjbtn"
            type="primary"
            @click="submitForm('ruleForm')"
            >提交</el-button
          >
        </el-form>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
// 手机验证
const funistel = (rule, value, callback) => {
  if (
    !/^((13[0|1|2|3|5|6|7|8|9])|(14[5|7|9])|(15[0|1|2|3|5|6|7|8|9])|(16[2|6])|(17[0|1|2|3|5|6|7|8])|(18[0-9])|(19[0|1|2|3|5|7|8|9])|)\d{8}$|^(134[0-8])\d{7}$|^\d{7,8}$|^0\d{2,3}-?\d{7,8}$|^400-?\d{7}$/.test(
      value.trim()
    )
  ) {
    callback("手机或电话信息有误");
  } else {
    callback();
  }
};
import Footer from "@/components/footer";
export default {
  components: {
    Footer,
  },
  data() {
    return {
      imageUrl: "",
      ruleForm: {
        name: "",
        phone: "",
      },
      rules: {
        phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { validator: funistel, trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
      },
      keyword: "",
      list: [],
      tabPosition: "left",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
    };
  },
  created() {
    this.company_card = "";
    this.agent_card = "";
    this.content = "";
    this.ruleForm = {};
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if(this.company_card==''){
            alert("请您上传营业执照！")
            return
          }
          if(this.agent_card==''){
            alert("请您上传代理记账许可证书！")
            return
          }
          console.log("我进来了吗", valid);
          this.$axios({
            url: "Index/agent_join",
            method: "post",
            data: {
              company_card: this.company_card,
              agent_card: this.agent_card,
              content: this.content,
              company_name: this.ruleForm.name,
              mobile: this.ruleForm.phone,
            },
          }).then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.$router.push({ path: "/index" });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleAvatarSuccess1(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(file, "1file是啥");
      this.company_card = file.response.data;
      console.log(this.company_card, "company_card");
    },
    handleAvatarSuccess2(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(file, "2file是啥");
      this.agent_card = file.response.data;
      console.log(this.agent_card, "agent_card");
    },
    handleAvatarSuccess3(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(file, "3file是啥");
      this.content = file.response.data;
      console.log(this.content, "content");
    },
    beforeAvatarUpload(file) {
      // 文件类型进行判断
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>
<style scoped lang="less">
.list {
  width: 100%;
  height: 250px;
  padding-top: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #e5e5e5;
}
.list_left {
  float: left;
  width: 75%;
}
.list_right {
  float: right;
  width: 267px;
  height: 180px;
  border: 1px solid #000;
  border-radius: 5px;
  box-sizing: content-box;
}
.list_right img {
  object-fit: contain;
  width: 267px;
  height: 180px;
}
.list_left h1 {
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-top: 25px;
}
.list_left p {
  padding-top: 30px;
  font-size: 18px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 60px;
}
.list_left div {
  margin-top: 50px;
  width: 78px;
  height: 27px;
  border-radius: 5px;
  border: 1px solid;
  color: #558bd4;
  line-height: 27px;
  text-align: center;
}
.page {
  padding-top: 20px;
  padding-bottom: 20px;
}
.bannery h1 {
  text-align: center;
  padding-top: 118px;
  font-size: 30px;
  color: #fff;
}
.bannery h2 {
  text-align: center;
  padding-top: 14px;
  font-size: 20px;
  color: #fff;
}
.bannery p {
  width: 100px;
  height: 44px;
  border: 1px solid;
  border-radius: 5px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  line-height: 44px;
  display: block;
  margin: 0 auto;
  margin-top: 65px;
}
.input_s {
  padding-top: 80px;
  margin: 0 auto;
  width: 500px;
  height: 40px;
  display: block;
  position: relative;
}
.upinput {
  width: 500px;
  height: 40px;
  display: block;
}
.rzpart1 {
}
.rzpart1 h1 {
  font-size: 40px;
  color: #fff;
  padding-top: 75px;
  font-weight: 800;
}
.rzpart1 h2 {
  font-size: 20px;
  color: #fff;
  padding-top: 20px;
}
.rzpart1 .to {
  display: inline-block;
  padding-top: 50px;
}
.to_img {
  padding-right: 25px;
}
.rzpart2 p {
  padding-top: 50px;
  padding-bottom: 50px;
  font-size: 40px;
  color: #fff;
  font-weight: 800;
}
.tab {
  width: 100%;
  height: 295px;
  border-radius: 5px;
  background: #fff;
}
.rzpart3 {
}
.rzpart3 p {
  color: #2c23cf;
  font-size: 40px;
  padding-top: 50px;
  padding-bottom: 50px;
  text-align: center;
  font-weight: 800;
}
.uload1 {
  display: inline-block;
  padding-right: 180px;
  padding-top: 80px;
}
.uload2 {
  padding-top: 80px;
  display: inline-block;
}
.uload3 {
  padding-top: 50px;
  display: inline-block;
  position: relative;
}
.form {
  padding-top: 50px;
}
.el-form-item {
  display: inline-block;
  padding-right: 100px;
}
.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
}
/deep/.el-input__inner {
  border: 1px solid #2c23cf;
  border-radius: 10px;
}
/deep/.el-form-item__label {
  color: #2c23cf;
  font-size: 20px;
  font-weight: 800;
}
/deep/.form input::placeholder {
  color: #2c23cf !important;
}
.tjbtn {
  width: 164px;
  height: 40px;
  margin: 0 auto;
  border-radius: 10px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  background: #2c23cf;
  margin-top: 50px;
  margin-bottom: 50px;
  margin-left: 320px;
}
/deep/.el-upload__tip {
  color: #2c23cf;
  font-size: 18px;
  font-weight: 800;
  text-align: center;
}
.scbtn {
  display: block;
  height: 39px;
  background: #2c23cf;
  text-align: center;
  border-radius: 18px;
  line-height: 39px;
  color: #fff;
  font-size: 18px;
  margin: 0 auto;
  margin-top: 20px;
  width: 140px;
}
/deep/.uload1 .el-upload-dragger .el-icon-upload {
  background: url(../assets/images/zzbtn.png) no-repeat;
  width: 106px;
  height: 112px;
}
/deep/.el-icon-upload:before {
  content: none;
}
/deep/.el-upload-dragger {
  height: 240px;
}
/deep/.uload2 .el-upload-dragger .el-icon-upload {
  background: url(../assets/images/dlbtn.png) no-repeat;
  width: 94px;
  height: 110px;
}
/deep/.uload3 .el-upload-dragger .el-icon-upload {
  background: url(../assets/images/qtbtn.png) no-repeat;
  width: 43px;
  height: 43px;
}
/deep/.uload1 .el-upload-list {
  width: 350px;
}
/deep/.uload2 .el-upload-list {
  width: 350px;
}
/deep/.uload3 .el-upload-dragger {
  width: 127px;
  height: 127px;
}
.bz {
  font-size: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: lighter;
  color: #2c23cf;
  text-align: center;
}
/deep/ .uload3 .el-upload__tip {
  color: #2c23cf;
  font-size: 18px;
  font-weight: 800;
  text-align: center;
  float: right;
  padding-left: 20px;
}
/deep/.el-upload-list__item-name {
  float: left;
}
/deep/.uload1 .el-upload-list__item-name {
  float: left;
  width: 320px;
}
/deep/.uload2 .el-upload-list__item-name {
  float: left;
  width: 320px;
}
.uload3 .bz {
  position: absolute;
  top: 85px;
  left: 150px;
}
.uload3 .scbtn {
  position: absolute;
  top: 110px;
  right: -520px;
}
/deep/.uload1 .el-upload-dragger .el-icon-upload {
  margin: 60px 0 16px;
}
/deep/.uload2 .el-upload-dragger .el-icon-upload {
  margin: 60px 0 16px;
}
/deep/ input[type="file"]{
  display: none;
}
</style>

